export const BI_CONSTANTS = {
  FLOWS: {
    DS: 'ds',
    POD: 'pod',
  },
  SCREENS: {
    CATEGORY_PAGE: 'category_page',
    PRODUCT_PAGE: 'product_page',
    CHAT: 'chat',
    TEMPLATE_PAGE: 'template_page',
    STORE_NAME_PAGE: 'store_name_page',
    SITE_PREVIEW_PAGE: 'site_preview_page',
    UNKNOWN: 'unknown',
    DOMAIN_PAGE: 'domain_page',
  },
  SCREEN_ERRORS: {
    PROFILE_BUILDER_DOWN: 'major_server_error',
  },
  TOASTS_NAMES: {
    ERRORS: {
      CHAT_GENERAL: 'minor_server_error',
      CHAT_EXCEEDING_TEXT: 'chat_exceeding_text',
    },
  },
  ACTION: {
    CATEGORY_PAGE_NEXT_LOGGED_USER: 'category_page_next_logged_in_user',
    CATEGORY_PAGE_NEXT_SIGNUP_USER: 'category_page_next_signup_user',
    PRODUCT_PAGE_NEXT: 'product_page_next',
    PRODUCT_PAGE_PREVIOUS: 'product_page_previous',
    THEME_SELECTOR_NEXT: 'theme_selector_next',
    MOBILE_GENERATE_SITE_FROM_CHAT: 'mobile_generate_site_from_chat',
    ACCEPT_PAYMENTS_ACCEPT: 'accept_payments_accept',
    ACCEPT_PAYMENTS_SKIP: 'accept_payments_skip',
    CHOOSE_DOMAIN_LETS_GO: 'choose_domain_lets_go',
    TEMPLATE_SELECTED: 'template_selected',
    VIEW_LIVE_SITE: 'view_live_site',
    DOMAIN_PAGE_NEXT: 'domain_page_next',
    DOMAIN_PAGE_SKIP: 'domain_page_skip',
    DOMAIN_PAGE_SUGGESTION_SELECT: 'domain_page_suggestion_select',
    DOMAIN_PAGE_SEARCH: 'domain_page_search',
  },
  BUTTON_NAME: {
    NEXT: 'next',
    PREVIOUS: 'previous',
    DESIGN_ONLINE_STORE: 'design_online_store',
    ACCEPT: 'accept',
    SKIP: 'skip',
    LETS_GO: 'lets_go',
    VIEW_LIVE_SITE: 'view_live_site',
    SELECT: 'select',
    SEARCH: 'search',
  },
  WIDGETS_VERSIONS: {
    V1: {
      END_CHAT_MESSAGE: 'end_chat_message_widget_v1',
      USER_PROFILE: 'user_profile_widget_v1',
      ACCEPT_PAYMENTS: 'accept_payments_widget_v1',
      CHOOSE_DOMAIN: 'choose_domain_widget_v1',
    },
  },
} as const;

export type ActionClickedParams = {
  action: (typeof BI_CONSTANTS.ACTION)[keyof typeof BI_CONSTANTS.ACTION];
  button_name?: (typeof BI_CONSTANTS.BUTTON_NAME)[keyof typeof BI_CONSTANTS.BUTTON_NAME];
  template_id?: string;
  // ... other existing params ...
};
